module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3-7cbc07dd3cffa42e9344f55b9e6adf75.webp";